/**
 * Cliente API de cuotas (Sprint 13 S13-04, migrado desde
 * frontend-superadmin tras la doctrina Portal vs Superadmin).
 *
 * Backend: `GET /cuotas/?lote_id=X&estado=pendiente` para poblar el
 * selector de cuotas pendientes del lote en el modal de clasificacion.
 */
import { apiFetch } from './client';
import type { CuotaRead, EstadoCuota } from './types';

export function listCuotas(filtros: {
  lote_id?: string;
  periodo?: string;
  estado?: EstadoCuota;
} = {}): Promise<CuotaRead[]> {
  const params = new URLSearchParams();
  if (filtros.lote_id) params.set('lote_id', filtros.lote_id);
  if (filtros.periodo) params.set('periodo', filtros.periodo);
  if (filtros.estado) params.set('estado', filtros.estado);
  const qs = params.toString();
  return apiFetch<CuotaRead[]>(`/cuotas/${qs ? `?${qs}` : ''}`);
}

// Genera las cuotas pendientes del periodo (YYYY-S1 / YYYY-S2), una por
// tenencia responsable activa. Idempotente: 409 si el periodo ya se generó.
// Backend: POST /cuotas/generar-semestre (require_tesorero).
export function generarCuotasSemestre(periodo: string): Promise<CuotaRead[]> {
  return apiFetch<CuotaRead[]>('/cuotas/generar-semestre', {
    method: 'POST',
    body: JSON.stringify({ periodo }),
  });
}

// Condona una cuota (la comisión decide no cobrarla; ej. deuda no traspasada
// en una venta). Motivo obligatorio. El actor (condonado_por) lo deriva el
// backend del JWT. Backend: POST /cuotas/{id}/condonar (require_tesorero).
// 409 si la cuota ya está pagada o condonada.
export function condonarCuota(
  cuotaId: string,
  motivo: string,
): Promise<CuotaRead> {
  return apiFetch<CuotaRead>(`/cuotas/${cuotaId}/condonar`, {
    method: 'POST',
    body: JSON.stringify({ motivo }),
  });
}
